import React from "react";

const SidebarLeft = () => {
  const server_folder = localStorage.getItem("server_folder");

  return (
    <nav id="sidebarleft" className="sidenav">
      <div id="dismiss">
        <i className="fas fa-times"></i>
      </div>
      <div className="sidebar-header">
        <h3>Account</h3>
      </div>
      <div className="sdprofile">
        <div className="sdp-left">
          <img src={server_folder + "/img/profile4.jpg"} alt="profile" />
        </div>
        <div className="sdp-right">
          <div className="sd-name">Lilia Doe</div>
          <div className="sd-status">+62123123123</div>
        </div>
      </div>
      <ul className="list-unstyled components">
        <li>
          <a href="/">
            <i className="fas fa-home"></i>Home
          </a>
        </li>
        <li>
          <a href="/book-car">
            <i className="fas fa-car"></i>Book a car
          </a>
        </li>
        <li>
          <a href="#pagemybooking" data-toggle="collapse" aria-expanded="false">
            <i className="fas fa-receipt"></i>My Bookings{" "}
            <span>
              <i className="fas fa-caret-down"></i>
            </span>
          </a>
          <ul className="collapse collapsible-body" id="pagemybooking">
            <li>
              <a href="/my-rides">My rides</a>
            </li>
            <li>
              <a href="/cart">Cart</a>
            </li>
            <li>
              <a href="/checkout">Checkout</a>
            </li>
          </ul>
        </li>
        <li>
          <a href="#pagemyaccount" data-toggle="collapse" aria-expanded="false">
            <i className="fas fa-user"></i>My Account{" "}
            <span>
              <i className="fas fa-caret-down"></i>
            </span>
          </a>
          <ul className="collapse collapsible-body" id="pagemyaccount">
            <li>
              <a href="/profile">Profile</a>
            </li>
            <li>
              <a href="/settings">Settings</a>
            </li>
          </ul>
        </li>
        <li>
          <a href="/car-list">
            <i className="fas fa-car"></i>Car list
          </a>
        </li>
        <li>
          <a href="/destinations">
            <i className="fas fa-map"></i>Destinations
          </a>
        </li>
        <li>
          <a href="/news">
            <i className="fas fa-newspaper"></i>News & travel guides
          </a>
        </li>
        <li>
          <a href="/rate">
            <i className="fas fa-star"></i>Rate
          </a>
        </li>
        <li>
          <a href="/feedback">
            <i className="fas fa-envelope"></i>Feedback
          </a>
        </li>
        <li>
          <a href="/about">
            <i className="fas fa-exclamation-circle"></i>About
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default SidebarLeft;
